import {mdiChevronDown, mdiClose} from "@mdi/js";
import Icon from "@mdi/react";
import React, {useEffect, useRef, useState} from "react";
import {useEnhancedTranslation} from "laravel-inertia-backend";

// Inlines Styles für Struktur
const closeButtonStyle = {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    fontSize: '24px',
};


const MailView = ({ mail,show, onClose, resizeRef, onResize  }) => {
    if (!show) {
        return null;
    }
    const {t, getLocales} = useEnhancedTranslation();
    const { subject, body, from, recipient, received_at } = mail;

    // Ref & State zur Nachverfolgung der Größe
    const mailViewRef = useRef(null);
    const [width, setWidth] = useState(null); // Default-Breite
    const [maxWidth, setMaxWidth] = useState(window.innerWidth); // Fallback
    const [isResizing, setIsResizing] = useState(false); // Status für Resizing
    const overlayRef = useRef(null); // Ref für transparentes Overlay

    useEffect(() => {
        if (resizeRef.current) {
            const parent = resizeRef.current.parentElement; // Nächstgelegener Container
            if (parent) {
                const parentRect = parent.getBoundingClientRect(); // Größe des UI-Containers
                setMaxWidth(parentRect.width); // Dynamische Maximalbreite setzen
            }
        }
    }, []);

    const handleMouseDown = (e) => {
        e.preventDefault();

        const startX = e.clientX; // Anfangsposition der Maus
        const startWidth = resizeRef.current.offsetWidth;

        // Overlay aktivieren
        setIsResizing(true);

        const handleMouseMove = (e) => {
            const delta = e.clientX - startX;
            let newWidth = startWidth + delta;

            // Dynamische Maximalbreite verwenden
            if (newWidth < 100) {
                newWidth = 100; // Mindestbreite
            } else if (newWidth > maxWidth) {
                newWidth = maxWidth; // Berechnete Maximalbreite
            }

            onResize(newWidth); // Breite aktualisieren
        };

        const handleMouseUp = () => {
            // Listener entfernen
            document.removeEventListener("mousemove", handleMouseMove);
            document.removeEventListener("mouseup", handleMouseUp);

            // Overlay deaktivieren
            setIsResizing(false);
        };

        // Listener hinzufügen
        document.addEventListener("mousemove", handleMouseMove);
        document.addEventListener("mouseup", handleMouseUp);
    };

    return (
        <div
            className="h-100 flex-grow-1"
            id="mail-view"
            ref={mailViewRef} // Ref binden
            style={{ position: "relative" }}
        >
            {/* Resizer */}
            <div
                className="mail-view-resizer"
                onMouseDown={handleMouseDown}
                style={{
                    width: "3px",
                    background: "rgba(34,34,34,0.6)",
                    cursor: "ew-resize",
                    position: "absolute",
                    top: 0,
                    bottom: 0,
                    left: 0,
                    height: "100%",
                }}
            />
            <div className={"mail-view-close"}>
                <button
                    onClick={onClose}
                    style={{background: "none", border: "none", cursor: "pointer"}}
                    aria-label="Close Event"
                >
                    <Icon color={"rgb(110,110,110)"} path={mdiClose} size={1}/>
                </button>
            </div>
            <div className="email-header">
                <h5>{subject}</h5>
                <p>
                    <strong>{t('From')}:</strong> {from} <br/>
                    <strong>{t('Date')}:</strong> {received_at}
                </p>
            </div>
            <div className="email-body h-100">
                <div className="email-content">
                    <p dangerouslySetInnerHTML={{__html: body}}></p>
                </div>
            </div>
        </div>
    );
};

export default MailView;
